import type { Action } from 'vuex'
import type { State } from './state'
import type { RecipientOptionList } from '@/api/send_cart/model/sendCartModel'

import actionTypes from './actionTypes'
import { getCarts, getCartsCount, getRecipientOptions } from '@/api/send_cart/send_cart'
import { SendCartTypeEnum } from '@/api/send_cart/model/sendCartModel'
import usePageData, { Feature, PageCode } from '@/hooks/core/usePageData'

const { savePageData } = usePageData()
const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_DETAIL]: async (
    { commit },
    sendCartType: SendCartTypeEnum
  ): Promise<void> => {
    const result = await getCarts(sendCartType)

    if (!result) {
      commit(actionTypes.SET_ALLOW_MOVE_TO_CONFIRM_VIEW, false)
      return
    }

    const data = result?.detail?.[0]
    const documentInCart: boolean = data.cart_document.length > 0

    if (documentInCart) {
      data.cart_document.forEach((item: any) => {
        if (item.revision_date) {
          const time = item.revision_date.split('/')
          item.revision_date = time[2] + '/' + time[0] + '/' + time[1]
        }
      })
    }

    commit(actionTypes.SET_DETAIL, data)
    commit(actionTypes.SET_SENDABLE_STATUS, result.sendable)
    commit(actionTypes.SET_SENDABLE_CHECKED_MESSAGE, result.message)
  },

  //送信先選択
  [actionTypes.SET_RECIPIENT_OPTIONS]: async ({ commit }): Promise<void> => {
    const result: RecipientOptionList | undefined = await getRecipientOptions()

    if (!result) {
      return
    }

    commit(actionTypes.SET_RECIPIENT_OPTIONS, result)
  },

  //sideBar
  [actionTypes.SET_SIDEBAR_CLICK]: async ({ commit }, status): Promise<void> => {
    commit(actionTypes.SET_SIDEBAR_CLICK, status)
  },

  [actionTypes.SET_ALLOW_MOVE_TO_CONFIRM_VIEW]({ commit }, status: boolean): void {
    commit(actionTypes.SET_ALLOW_MOVE_TO_CONFIRM_VIEW, status)
  },
}

export default actions
